<template>
  <div :class="{'op--modal-container':true, 'hide':!show}">
    <div class="op--modal">
      <div class="op--modal-content" id="form">
        <div class="form">
          <div class="heading">
            <span v-if="id === null">NEW DEDUCTION</span>
            <span v-else>EDITING DEDUCTION</span>
          </div>
          <div class="row row-padding">
            <div class="small-12 columns">
              <div class="data-field">
                <div class="label">NAME</div>
                <input type="text" class="input" v-model="name" />
                <span class="hint">This will appear on the driver's payout statement.</span>
              </div>
            </div>
          </div>
          <div class="row row-padding">
            <div class="small-12 columns">
              <div class="data-field">
                <div class="label">DESCRIPTION</div>
                <textarea class="input" v-model="description"></textarea>
              </div>
            </div>
          </div>

          <div class="row row-padding">
            <div class="small-6 inputDate columns padding-R">
              <div class="data-field">
                <div class="label">START DATE</div>
                <datepicker class="datepicker" v-model="effectiveStart" format="MMMM dd, yyyy"></datepicker>
              </div>
            </div>
            <div class="small-6 inputDate columns padding-L">
              <div class="data-field end-date">
                <div class="label">END DATE</div>
                <datepicker class="datepicker" v-model="effectiveEnd" format="MMMM dd, yyyy"></datepicker>
              </div>
            </div>
          </div>

          <div class="row row-padding">
            <div class="small-6 columns padding-R">
              <div class="data-field">
                <div class="label">DEDUCTION INTERVAL</div>
                <select v-model="selectedInterval">
                  <option v-for="i in interval" :value="i">{{ucFirst(i)}}</option>
                </select>
              </div>
            </div>
            <div class="small-6 columns padding-L">
              <div class="data-field">
                <div class="label">AMOUNT</div>
                <input type="number" class="input" v-model.number="amount" />
              </div>
            </div>
          </div>

          <div class="row row-padding">
            <div class="small-6 columns padding-R">
              <div class="data-field" v-show="selectedInterval === 'weekly'">
                <div class="label">WEEKLY ANCHOR</div>
                <select v-model="selectedWeeklyAnchor">
                  <option v-for="i in weeklyAnchor" :value="i">{{ucFirst(i)}}</option>
                </select>
              </div>
              <div class="data-field" v-show="selectedInterval === 'monthly'">
                <div class="label">MONTHLY ANCHOR</div>
                <select v-model.number="selectedMonthlyAnchor">
                  <option v-for="n in monthlyAnchor" :value="n">{{ daySuffix(n) }} of the month</option>
                </select>
              </div>
            </div>
            <div class="small-6 columns padding-L">
              <div class="data-field">
                <div class="label">ENABLED</div>
                <select v-model.boolean="enabled">
                  <option :value="false">No</option>
                  <option :value="true">Yes</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row row-padding apply-checkbox">
            <div class="small-4 columns top-apply">
              <label class="checkbox-input">
                <input type="checkbox" v-model.boolean="applyTNC" />
                <span>Apply to <b>TNC</b></span>
              </label>
            </div>
            <div class="small-4 columns top-apply">
              <label class="checkbox-input">
                <input type="checkbox" v-model.boolean="applyTCP" />
                <span>Apply to <b>TCP</b></span>
              </label>
            </div>
            <div class="small-4 columns bottom-apply">
              <label class="checkbox-input">
                <input type="checkbox" v-model.boolean="applyPSC" />
                <span>Apply to <b>PSC</b></span>
              </label>
            </div>
          </div>

          <div class="error" v-show="error.show">{{ error.message }}</div>

          <div class="fixed-footer">
            <div :class="{'button cta small warning':true, 'disabled':submitLoading}"
              @click="close">CANCEL</div>
            <div :class="{'button cta small':true, 'disabled':submitLoading}"
              @click="submitForm">
              <span v-if="id !== null">SAVE</span>
              <span v-else>ADD</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
export default {
  name: 'deduction-form',
  components: { datepicker },
  data () {
    return {
      submitLoading: false,
      error: {
        show: false,
        message: 'Please select a valid value'
      }
    }
  },
  computed: {
    show () { return this.$store.state.providerDeductions.deductionForm.show },
    interval () { return this.$store.state.providerDeductions.deductionForm.interval },
    weeklyAnchor () { return this.$store.state.providerDeductions.deductionForm.weeklyAnchor },
    monthlyAnchor () { return this.$store.state.providerDeductions.deductionForm.monthlyAnchor },
    id () { return this.$store.state.providerDeductions.deductionForm.id },
    name: {
      get () { return this.$store.state.providerDeductions.deductionForm.name },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormName', value) }
    },
    description: {
      get () { return this.$store.state.providerDeductions.deductionForm.description },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormDescription', value) }
    },
    amount: {
      get () { return this.$store.state.providerDeductions.deductionForm.amount },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormAmount', value) }
    },
    effectiveStart: {
      get () {
        if (this.$store.state.providerDeductions.deductionForm.effectiveStart === null) {
          return null
        }
        return this.$store.state.providerDeductions.deductionForm.effectiveStart.toDate()
      },
      set (value) {
        let temp = moment(value)
        let startDate = moment(temp.format('YYYY-MM-DD') + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss')
        this.$store.commit('providerDeductions/setDeductionFormEffectiveStart', startDate)
      }
    },
    effectiveEnd: {
      get () {
        if (this.$store.state.providerDeductions.deductionForm.effectiveEnd === null) {
          return null
        }
        return this.$store.state.providerDeductions.deductionForm.effectiveEnd.toDate()
      },
      set (value) {
        let temp = moment(value)
        let endDate = moment(temp.format('YYYY-MM-DD') + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss')
        this.$store.commit('providerDeductions/setDeductionFormEffectiveEnd', endDate)
      }
    },
    enabled: {
      get () { return this.$store.state.providerDeductions.deductionForm.enabled },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormEnabled', value) }
    },
    selectedInterval: {
      get () { return this.$store.state.providerDeductions.deductionForm.selectedInterval },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormSelectedInterval', value) }
    },
    selectedWeeklyAnchor: {
      get () { return this.$store.state.providerDeductions.deductionForm.selectedWeeklyAnchor },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormSelectedWeeklyAnchor', value) }
    },
    selectedMonthlyAnchor: {
      get () { return this.$store.state.providerDeductions.deductionForm.selectedMonthlyAnchor },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormSelectedMonthlyAnchor', value) }
    },
    applyTNC: {
      get () { return this.$store.state.providerDeductions.deductionForm.applyTNC },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormApplyTNC', value) }
    },
    applyTCP: {
      get () { return this.$store.state.providerDeductions.deductionForm.applyTCP },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormApplyTCP', value) }
    },
    applyPSC: {
      get () { return this.$store.state.providerDeductions.deductionForm.applyPSC },
      set (value) { this.$store.commit('providerDeductions/setDeductionFormApplyPSC', value) }
    }
  },
  methods: {
    close () { this.$store.commit('providerDeductions/setDeductionFormShow', false) },
    ucFirst (string) { return string.charAt(0).toUpperCase() + string.slice(1) },
    daySuffix (i) {
      let j = i % 10
      let k = i % 100
      if (j == 1 && k != 11) {
          return i + "st"
      }
      if (j == 2 && k != 12) {
          return i + "nd"
      }
      if (j == 3 && k != 13) {
          return i + "rd"
      }
      return i + "th"
    },
    isValid (form) {
      let self = this
      self.error = {
        show: false,
        message: ''
      }

      if (form.name === '') {
        self.error = {
          show: true,
          message: '\'Name\' is a required field.'
        }
        return false
      }

      if (form.description === '') {
        self.error = {
          show: true,
          message: '\'Description\' is a required field.'
        }
        return false
      }

      if (form.amount === '') {
        self.error = {
          show: true,
          message: '\'Amount\' is a required field.'
        }
        return false
      }

      if (form.effectiveStart === null) {
        self.error = {
          show: true,
          message: '\'Start Date\' is a required field.'
        }
        return false
      }

      if (form.effectiveEnd === null) {
        self.error = {
          show: true,
          message: '\'End Date\' is a required field.'
        }
        return false
      }

      if (form.effectiveEnd.isBefore(form.effectiveStart)) {
        self.error = {
          show: true,
          message: '\'End Date\' must be on or after \'Start Date\'.'
        }
        return false
      }

      if (form.amount <= 0) {
        self.error = {
          show: true,
          message: '\'Amount\' must be a number greater than 0.'
        }
        return false
      }

      if (!form.applyTNC && !form.applyTCP && !form.applyPSC) {
        self.error = {
          show: true,
          message: 'Please select at least one applicable license (TNC, TCP or PSC).'
        }
        return false
      }
      return true
    },
    submitForm () {
      let self = this
      let request = {
        token: self.$store.state.session.sessionToken,
        name: self.name,
        description: self.description,
        amount: self.amount,
        effectiveStart: self.effectiveStart === null ? null : moment(self.effectiveStart),
        effectiveEnd: self.effectiveEnd === null ? null : moment(self.effectiveEnd),
        enabled: self.enabled,
        interval: self.selectedInterval,
        weeklyAnchor: self.selectedWeeklyAnchor,
        monthlyAnchor: self.selectedMonthlyAnchor,
        applyTNC: self.applyTNC,
        applyTCP: self.applyTCP,
        applyPSC: self.applyPSC
      }
      if (!self.isValid(request)) {
        return
      }
      request.effectiveStart = request.effectiveStart.format('YYYY-MM-DD HH:mm:ss')
      request.effectiveEnd = request.effectiveEnd.format('YYYY-MM-DD HH:mm:ss')
      if (request.interval === 'weekly') {
        request.monthlyAnchor = null
      }
      if (request.interval === 'monthly') {
        request.weeklyAnchor = null
      }

      let url = '/admin/providerdeduction'
      if (self.id !== null) {
        url = url + '/' + self.id
      }

      self.submitLoading = true
      self.$sdk.post(url, request, r => {
        console.log(r)
        self.submitLoading = false
        if (r.error) {
          self.error = {
            show: true,
            message: r.error.message
          }
          return
        }

        self.$store.commit('providerDeductions/setDeductionListReload', true)
        self.$store.commit('providerDeductions/setDeductionFormShow', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}
.form{
  background: #fff;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  border-radius: 5px;
  overflow: hidden;
}
.heading{
  background: #333;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  padding: 10px 20px;
  margin-bottom: 20px;
}

.row-padding{ padding: 2px 20px; }
.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }
.margin-B{ margin-bottom: 20px; }


.data-field{
  position: relative;
  margin-bottom: 10px;
  & .label{
    color: #0D79F2;
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 1px;

    &.has-error{ color: #f20d0d; }
  }
  & .input{
    margin: 5px 0 0;
    padding: 10px;
    font-size: 14px;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;
    border-radius: 3px;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  & .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
  & .hint {
    font-size: 12px;
    color: #555;
    line-height: 1;
  }

  & textarea {
    resize: none;
    font-size: 14px;
    height: 150px;
    padding: 10px;
  }

  & select {
    margin-top: 5px;
    font-size: 14px;
    padding: 10px;
    height: 43px;
    outline: 0;
    display: block;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }
}

.checkbox-input {
  display: block;
  text-align: center;
  margin: 10px 0;
  & > input {
    margin-top: 0;
    width: auto;
  }

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & > span {
    font-size: 14px;
  }
}

.error {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  color: #F25E0D;
  border: 2px solid #F25E0D;
  padding: 10px;
  margin: 10px 20px 20px;
  border-radius: 5px;
}

.fixed-footer{
  width: 100%;
  background: #f3f3f3;
  border-top:1px solid #ccc;
  padding: 15px 10px;
  text-align: center;
  margin-top: 15px;

  .button{
    min-width: 120px;
    margin: 0 5px;
  }
}

@media only screen and (max-width: 430px) {
  .form {
    width: 90%;
    .small-6.inputDate {
      width: 100%;
      padding: 0;
    }
    .apply-checkbox {
      display: grid;
      grid-template-rows: auto;
      grid-template-areas:
        "top-apply top-apply"
        "bottom-apply bottom-apply";
    }
    .end-date {
      /deep/ .vdp-datepicker__calendar {
        right: 1px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProviderDeductions/DeductionForm.vue